@if (primaryPlan) {
<div class='main-wrapper' sxPadding='medium' sxRadius='16px' sxRow sxDistribution='spaceBetween' sxAlign='center'>
  <div sxRow sxGap='10px'>
    <ion-icon sxTextSize='large' name='diamond'></ion-icon>
    <p sxMargin='0' sxTextWeight='bold'>{{primaryPlan.name}}</p>
  </div>
</div>
}
@if (!primaryPlan) {
<div sxBackground='light' sxWidth='full' sxPadding='medium' sxRadius='16px' sxRow sxDistribution='spaceBetween'
  sxAlign='center' (click)='openPlanUpgrade()'>
  <div sxRow sxGap='8px'>
    <ion-icon sxTextSize='large' name='diamond'></ion-icon>
    <p sxMargin='0'>Free</p>
  </div>
  <div sxRow sxAlign='center'>
    <p sxMargin='0' sxTextSize='small'>Upgrade</p>
    <ion-icon name='chevron-forward'></ion-icon>
  </div>
</div>
}